export const CapitalizeFirstLetter = (str) => {
  if (!str) return ''; 
  return str.charAt(0).toUpperCase();
  };